<template>
  <section class="logic-args-section">
    <!-- 标题与操作区 -->
    <div class="x-args-header section-header-band">
      <div class="header-left">
        <el-button v-if="!readOnly" type="primary" size="small" icon="el-icon-plus" @click="handleAdd" class="btn-action">新增</el-button>
        <span class="args-section-title">{{ title }}</span>
      </div>
      <span></span>
    </div>

    <table-page
      :loading="loading"
      :empty="filteredArgsList.length === 0"
      :show-top-pagination="false"
      :show-bottom-pagination="false"
      @retry="fetchData"
    >
    <el-table :data="filteredArgsList" stripe style="width: 100%" class="premium-table">
      <el-table-column v-if="visibleColumns.includes('argsId')" key="col-argsId" prop="argsId" label="ArgsId" width="160" :formatter="argsIdFormatter">
        <template slot-scope="scope">
          <span class="args-id-tag">{{ argsIdFormatter(scope.row, null, scope.row.argsId) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="visibleColumns.includes('logicId')" key="col-logicId" prop="logicId" label="LogicId" min-width="160">
        <template slot-scope="scope">
          <el-link type="primary" class="logic-name-link" :underline="false">
            {{ logicIdFormatter(scope.row, null, scope.row.logicId) }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column v-if="visibleColumns.includes('args')" key="col-args" prop="args" label="Args" min-width="100">
        <template slot-scope="scope">
          <el-popover placement="top-start" trigger="click" :content="scope.row.args">
            <div>
              {{ scope.row.args }}
              <el-button type="text" size="mini" icon="el-icon-copy-document" @click="handleValueCopy(scope.row.args)" class="copy-btn">复制</el-button>
            </div>
            <el-link slot="reference" type="primary" :underline="false" class="view-link">查看</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column v-for="item in visibleSwitchProps" :key="'col-switch-' + item.prop" :prop="item.prop" :label="item.label" width="100" align="center">
        <template slot-scope="scope">
          <span :class="['status-simple-badge', scope.row[item.prop] ? 'active' : 'inactive']">
            <span class="dot"></span>
            {{ scope.row[item.prop] ? '开启' : '关闭' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column key="col-actions" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-dropdown @command="cmd => handleActionCommand(cmd, scope.$index, scope.row)" trigger="hover">
            <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" :disabled="readOnly">
                <i class="el-icon-edit"></i> 编辑参数
              </el-dropdown-item>
              <el-dropdown-item command="delete" :disabled="readOnly" style="color: #ef4444;">
                <i class="el-icon-delete" style="color: #ef4444;"></i> 删除参数
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    </table-page>

    <el-drawer
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="drawerSize"
      append-to-body
      destroy-on-close
      custom-class="logic-args-drawer"
      :with-header="false"
    >
      <div class="drawer-header">
        <div class="drawer-title-wrap">
          <span class="drawer-title-icon"><i :class="isFormAdd ? 'el-icon-plus' : 'el-icon-edit-outline'"></i></span>
          <span class="drawer-title">{{ isFormAdd ? '新增逻辑参数' : '编辑逻辑参数' }}</span>
        </div>
        <div class="header-right-buttons">
          <el-button size="small" @click="dialogVisible = false"><i class="el-icon-back"></i> 返回列表</el-button>
          <el-button v-if="!readOnly" type="success" size="small" :loading="saveLoading" :disabled="saveLoading" @click="handleDialogSave">保存</el-button>
        </div>
      </div>

      <div class="drawer-content">
      <el-form :model="form" ref="form" label-position="right" label-width="150px" size="small" class="args-premium-form drawer-horizontal-form">
        <el-form-item label="LogicId" prop="logicId">
          <el-select v-model="form.logicId" filterable placeholder="请选择" style="width: 100%;" @change="handleLogicChange(form.logicId)" clearable>
            <el-option v-for="item in logicMap" :key="item[0]" :label="item[1].logicId + ' - ' + item[1].name" :value="item[1].logicId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-for="item in switchProps" :key="item.prop" :prop="item.prop" :label="item.label" class="switch-form-item">
          <el-switch v-model="form[item.prop]"></el-switch>
        </el-form-item>

        <el-form-item label="Args" prop="args" class="args-form-item">
          <div class="args-toolbar">
            <el-button size="mini" plain icon="el-icon-refresh" @click="handleFillArgs()" v-if="!isFormAdd && !readOnly">填充参数</el-button>
            <el-button type="text" size="mini" icon="el-icon-copy-document" @click="handleValueCopy(form.args)" class="copy-btn">复制</el-button>
            <el-button type="text" size="mini" icon="el-icon-view" @click="viewVisible = !viewVisible" class="copy-btn">{{ viewVisible ? '隐藏JSON' : '查看JSON' }}</el-button>
          </div>
          <p v-if="viewVisible" class="args-json-preview">{{ form.args }}</p>
          <!-- 参数编辑表格 -->
          <el-table :data="form.args" size="mini" class="args-edit-table" v-if="form.args && form.args.length">
            <el-table-column prop="label" label="参数名" min-width="120">
              <template slot-scope="scope">
                <span class="args-label-text">{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="参数值" min-width="200">
              <template slot-scope="scope">
                <div class="editable-cell">
                  <el-input v-model="scope.row.value" size="mini" placeholder="请输入参数值"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" v-if="form.args.some(a => a.show)">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isKeep" v-if="scope.row.show">保留(模板已无此参数)</el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      </div>

    </el-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import TablePage from '@/components/TablePage/index.vue'

export default {
  name: 'XsLogicArgs',
  components: { TablePage },
  props: {
    ownerType: {
      type: Number, // 0=channel, 1=game
      default: 0
    },
    argsId: {
      type: Number,
      default: 0
    },
    logicType: {
      type: Number, // 1=login, 2=pay
      default: 1
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    visibleColumns: {
      type: Array,
      default: () => ['argsId', 'logicId', 'args', 'loginOpen', 'registerOpen', 'fastRegisterOpen', 'open']
    }
  },
  data () {
    return {
      logicMap: new Map(),
      argsList: [],
      dialogVisible: false,
      form: {},
      isFormAdd: true,
      logic: {},
      viewVisible: false,
      originalArgsList: [],
      deletedList: [],
      loading: false,
      saveLoading: false
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    gameMap () {
      return this.$store.getters.appMap
    },
    channelMap () {
      return this.$store.getters.channelMap
    },
    title () {
      const owner = this.ownerType === 1 ? '游戏' : '渠道'
      const type = this.logicType === 1 ? 'Login' : 'Pay'
      return `${owner} ${this.argsId} ${type} Args`
    },
    loginSwitchProps () {
      return [
        { prop: 'loginOpen', label: '登录' },
        { prop: 'registerOpen', label: '注册' },
        { prop: 'fastRegisterOpen', label: '快速注册' }
      ]
    },
    paySwitchProps () {
      return [{ prop: 'open', label: '开启' }]
    },
    switchProps () {
      if (this.isLogicTypeLogin()) {
        return this.loginSwitchProps
      }
      return this.paySwitchProps
    },
    visibleSwitchProps () {
      return this.switchProps.filter(item => this.visibleColumns.includes(item.prop))
    },
    filteredArgsList () {
      const keyword = String(this.keyword || '').trim().toLowerCase()
      if (!keyword) return this.argsList
      return this.argsList.filter(row => Object.keys(row).some(key => String(row[key] ?? '').toLowerCase().includes(keyword)))
    },
    drawerSize () {
      return this.$store.getters.isMobile ? '100%' : '50%'
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    isLogicTypeLogin () {
      return this.logicType === 1
    },
    ifLogicTypePay () {
      return this.logicType === 2
    },
    fetchData () {
      this.loading = true
      const logicRequest = api.getXsLogicData(this.logicType).then(res => {
        const logicMap = new Map()
        for (const item of res) {
          logicMap.set(item.logicId, item)
        }
        this.logicMap = logicMap
      })
      const func = this.isLogicTypeLogin() ? api.getXsArgsLoginList : api.getXsArgsPayList
      const argsRequest = func(this.argsId).then(res => {
        this.argsList = res || []
        this.originalArgsList = JSON.parse(JSON.stringify(res || []))
        this.deletedList = []
      })
      return Promise.all([logicRequest, argsRequest]).finally(() => {
        this.loading = false
      })
    },
    getLogic (logicId) {
      return this.logicMap.get(logicId) || {}
    },
    argsIdFormatter (row, col, cellValue) {
      if (this.ownerType === 1) {
        const game = this.gameMap.get(cellValue)
        return game ? cellValue + '-' + game.name : cellValue
      }
      const channel = this.channelMap.get(cellValue)
      return channel ? cellValue + '-' + channel.name : cellValue
    },
    logicIdFormatter (row, col, cellValue) {
      return cellValue + '-' + this.getLogic(cellValue).name
    },
    handleValueCopy (value) {
      navigator.clipboard.writeText(value).then(() => {
        this.$message.success('复制成功')
      })
    },
    handleAdd () {
      this.isFormAdd = true
      this.form = {
        logicId: '',
        type: 0,
        open: true,
        loginOpen: true,
        registerOpen: true,
        fastRegisterOpen: false,
        args: []
      }
      this.dialogVisible = true
      this.tableDataIndex = -1
    },
    handleEdit (index, row) {
      this.isFormAdd = false
      this.tableDataIndex = this.argsList.indexOf(row)
      const obj = JSON.parse(JSON.stringify(row))
      obj.args = JSON.parse(obj.args || '{}')
      obj.args = this.mapLogicArgs(JSON.parse(this.getLogic(obj.logicId).args), obj.args)
      this.form = obj
      this.dialogVisible = true
    },
    // 返回值 [ { "label": "A", "key": "a", "value": "1" }, { "label": "B", "key": "b", "value": "2" }, { "label": "C", "key": "c" } ]
    mapLogicArgs (arr, obj) {
      // arr是模版数组 [{"label":"A","key":"a","value":"a1"},{"label":"B","key":"b","value":"b1"}]
      // obj是参数对象 { "a": "1", "b": "2" }
      const arrMap = new Map()
      for (const item of arr) {
        arrMap.set(item.key, item)
        item.value = obj[item.key]
      }
      for (const item in obj) {
        if (!arrMap.has(item)) {
          arr.push({ key: item, value: obj[item], label: item, isKeep: true, show: true })
        }
      }
      return arr
    },
    // 填充参数
    handleFillArgs () {
      const args = this.getLogic(this.form.logicId).args
      const logicTemplate = args ? JSON.parse(args) : null
      const logicTemplateMap = new Map()
      for (const item of logicTemplate) {
        logicTemplateMap.set(item.key, item)
      }
      if (logicTemplate) {
        for (const item of this.form.args) {
          if (!item.value) {
            item.value = logicTemplateMap.get(item.key).value
          }
        }
      }
    },
    handleLogicChange (logicId) {
      const logic = this.getLogic(logicId)
      this.form.args = JSON.parse(logic.args || '[]')
    },
    handleDialogSave () {
      if (this.saveLoading) return
      this.saveLoading = true
      const data = JSON.parse(JSON.stringify(this.form))
      const args = {}
      for (const item of data.args) {
        args[item.key] = item.value
        if (Object.prototype.hasOwnProperty.call(item, 'isKeep') && !item.isKeep) {
          delete args[item.key]
        }
      }
      data.ownerType = this.ownerType
      data.argsId = this.argsId
      data.args = JSON.stringify(args)

      if (this.isFormAdd) {
        data.id = 'temp_' + Date.now() + Math.random().toString(36).substr(2, 5)
        this.argsList.push(data)
      } else {
        this.argsList.splice(this.tableDataIndex, 1, data)
      }

      this.dialogVisible = false
      this.$message.success(this.isFormAdd ? '已暂存添加' : '已暂存修改')
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
      this.$nextTick(() => {
        this.saveLoading = false
      })
    },
    handleDelete (index, row) {
      this.$confirm('是否移除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row.id && String(row.id).indexOf('temp_') !== 0) {
          this.deletedList.push(row.id)
        }
        const dataIndex = this.argsList.indexOf(row)
        if (dataIndex >= 0) this.argsList.splice(dataIndex, 1)
        this.$message.success('已暂存删除')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleActionCommand (command, index, row) {
      if (command === 'edit') {
        this.handleEdit(index, row)
      } else if (command === 'delete') {
        this.handleDelete(index, row)
      }
    },
    getChanges () {
      const created = []
      const updated = []
      const deleted = [...this.deletedList]

      this.argsList.forEach(item => {
        if (item.id && String(item.id).indexOf('temp_') === 0) {
          const newItem = { ...item }
          delete newItem.id
          created.push(newItem)
        } else {
          const orig = this.originalArgsList.find(o => o.id === item.id)
          if (orig) {
            const fields = ['logicId', 'args', 'open', 'loginOpen', 'registerOpen', 'fastRegisterOpen']
            let hasChanged = false
            for (const f of fields) {
              if (item[f] !== orig[f]) {
                hasChanged = true
                break
              }
            }
            if (hasChanged) {
              updated.push(item)
            }
          }
        }
      })

      return { created, updated, deleted }
    },
    getDisplayDiff () {
      const { created, updated, deleted } = this.getChanges()
      const diffLogs = []
      const typeLabel = this.isLogicTypeLogin() ? '官方登录' : '官方支付'

      created.forEach(item => {
        const name = (this.getLogic(item.logicId) || {}).name || item.logicId
        diffLogs.push(`[${typeLabel}] 新增配置项: 逻辑模板 [${item.logicId}-${name}]`)
      })

      updated.forEach(item => {
        const name = (this.getLogic(item.logicId) || {}).name || item.logicId
        diffLogs.push(`[${typeLabel}] 修改配置项: 逻辑模板 [${item.logicId}-${name}]`)
      })

      deleted.forEach(id => {
        const orig = this.originalArgsList.find(o => o.id === id)
        const name = orig ? ((this.getLogic(orig.logicId) || {}).name || orig.logicId) : id
        diffLogs.push(`[${typeLabel}] 删除配置项: 逻辑模板 [${orig ? orig.logicId : ''}-${name}]`)
      })

      return diffLogs
    },
    getExportData (typeLabel) {
      return this.filteredArgsList.map(row => ({
        类型: typeLabel,
        ArgsId: row.argsId,
        LogicId: row.logicId,
        Args: row.args,
        登录: row.loginOpen,
        注册: row.registerOpen,
        快速注册: row.fastRegisterOpen,
        支付开启: row.open
      }))
    }
  }
}
</script>

<style scoped>
/* 表格卡片样式 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
  margin-bottom: 20px;
}

/* 标题区 */
.x-args-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.logic-args-section {
  margin-bottom: 20px;
}

.section-header-band {
  margin-bottom: 12px;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.args-section-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-main);
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

/* Premium 表格 */
.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right .el-table__fixed-header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td,
.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

/* ID Tag 样式 */
.args-id-tag {
  font-size: 11px;
  color: var(--text-muted);
  background: var(--bg-hover);
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;
  letter-spacing: 0.2px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

/* Logic名称链接 */
.logic-name-link {
  font-weight: 600;
  font-size: 13px;
}

.logic-name-link:hover {
  text-decoration: none !important;
}

/* 查看链接 */
.view-link {
  font-size: 13px;
  font-weight: 500;
}

/* 复制按钮 */
.copy-btn {
  color: var(--primary-color) !important;
  font-size: 12px;
}

/* 操作列三点图标 */
.action-btn {
  font-size: 12px;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
  background: var(--bg-card);
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: var(--bg-hover);
  color: var(--text-main);
  border-color: var(--border-hover);
}

/* 弹窗样式 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

/* 弹窗表单 */
.args-premium-form :deep(.el-form-item__label) {
  font-weight: 600;
  color: var(--text-main);
  padding-bottom: 6px !important;
}

.args-premium-form :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: var(--border-color);
  background-color: var(--bg-card);
  color: var(--text-main);
}

.args-premium-form :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.args-premium-form .is-full-width {
  width: 100%;
}

/* Args 工具栏 */
.args-toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
}

/* Args JSON 预览 */
.args-json-preview {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: var(--text-muted);
  background: var(--bg-page);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 12px;
  word-break: break-all;
  line-height: 1.6;
}

/* Args 编辑表格 */
.args-edit-table {
  border: 1px solid var(--border-color) !important;
  border-radius: 8px;
  overflow: hidden;
  background-color: var(--bg-card);
}

.args-edit-table :deep(.el-table__header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 600 !important;
  padding: 8px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.args-edit-table :deep(.el-table__row) td {
  padding: 6px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.args-label-text {
  font-weight: 600;
  color: #475569;
  font-size: 13px;
}

/* 保存按钮 */
.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

:deep(.logic-args-drawer) {
  background: #f8fafc;
}

:deep(.logic-args-drawer .el-drawer__body) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 12px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-title-wrap,
.header-right-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-right-buttons {
  flex-shrink: 0;
  gap: 8px;
  margin-left: auto;
}

.drawer-title-icon {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.drawer-title {
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
}

.drawer-close-btn {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-color: #e2e8f0 !important;
  border-radius: 8px !important;
  color: #64748b !important;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.drawer-horizontal-form :deep(.el-form-item) {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.drawer-horizontal-form :deep(.el-form-item__label) {
  width: 150px !important;
  flex: 0 0 150px;
  padding: 0 16px 0 0 !important;
  color: #475569;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
}

.drawer-horizontal-form :deep(.el-form-item__content) {
  min-width: 0;
  flex: 1;
  margin-left: 0 !important;
}

.drawer-horizontal-form :deep(.el-select),
.drawer-horizontal-form :deep(.el-input) {
  width: 100%;
}

.switch-form-item :deep(.el-form-item__content) {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.args-form-item :deep(.el-form-item__content) {
  overflow: hidden;
}

.editable-cell {
  position: relative;
}

.editable-cell::after {
  content: "\e78c";
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  color: #94a3b8;
  font-family: element-icons !important;
  font-size: 12px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.args-edit-table :deep(.el-input__inner) {
  height: 30px;
  padding-right: 28px;
  border-color: transparent;
  border-radius: 6px;
  background: transparent;
  color: #334155;
  cursor: text;
  transition: all 0.2s ease;
}

.args-edit-table :deep(.el-table__row:hover .el-input__inner) {
  border-color: #cbd5e1;
  background: #ffffff;
  color: var(--primary-color);
}

.args-edit-table :deep(.el-table__row:hover) .editable-cell::after {
  opacity: 1;
}

.args-edit-table :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
  color: #1e293b;
}

.drawer-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-footer .el-button + .el-button,
.drawer-footer-actions .el-button + .el-button {
  margin-left: 0;
}

@media (max-width: 768px) {
  .drawer-content {
    margin: 8px;
    padding: 16px;
  }

  .drawer-horizontal-form :deep(.el-form-item) {
    display: block;
  }

  .drawer-horizontal-form :deep(.el-form-item__label) {
    width: 100% !important;
    padding-right: 0 !important;
  }
}

/* Switch 统一样式微调 */
:deep(.el-switch.is-disabled) {
  opacity: 0.95;
}
:deep(.el-switch.is-disabled .el-switch__core) {
  cursor: default;
}

/* ==========================================================================
   XS LogicArgs 逻辑参数页面与抽屉暗色模式适配覆盖
   ========================================================================== */
html.dark .table-card,
html.dark .drawer-content {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

html.dark .section-header-band {
  background: var(--bg-card) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.25) !important;
}

html.dark .args-section-title {
  color: var(--text-main) !important;
}

html.dark .premium-table {
  color: var(--text-main) !important;
}

html.dark .premium-table :deep(.el-table__header-wrapper) th,
html.dark .premium-table :deep(.el-table__fixed-header-wrapper) th,
html.dark .premium-table :deep(.el-table__fixed-right .el-table__fixed-header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  border-bottom-color: var(--border-color) !important;
}

html.dark .premium-table :deep(.el-table__row) td {
  border-bottom-color: var(--border-light) !important;
}

html.dark .premium-table :deep(.el-table__row:hover) td,
html.dark .premium-table :deep(.el-table__body tr.hover-row > td),
html.dark .premium-table :deep(.el-table__body tr.hover-row.current-row > td),
html.dark .premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

html.dark .args-id-tag {
  color: var(--text-muted) !important;
  background: var(--bg-hover) !important;
}

html.dark .action-btn {
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  background: var(--bg-card) !important;
}

html.dark .action-btn:hover {
  background: var(--bg-hover) !important;
  color: var(--text-main) !important;
  border-color: var(--border-hover) !important;
}

html.dark .args-premium-form :deep(.el-input__inner) {
  border-color: var(--border-color) !important;
}

html.dark .args-json-preview {
  color: var(--text-muted) !important;
  background: var(--bg-page) !important;
  border-color: var(--border-color) !important;
}

html.dark .args-edit-table {
  border-color: var(--border-color) !important;
}

html.dark .args-edit-table :deep(.el-table__header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  border-bottom-color: var(--border-color) !important;
}

html.dark .args-edit-table :deep(.el-table__row) td {
  border-bottom-color: var(--border-light) !important;
}

html.dark .args-label-text {
  color: var(--text-muted) !important;
}

html.dark :deep(.logic-args-drawer) {
  background: var(--bg-page) !important;
}

html.dark .drawer-header {
  border-bottom-color: var(--border-color) !important;
  background: var(--bg-card) !important;
}

html.dark .drawer-title-icon {
  background: rgba(59, 130, 246, 0.15) !important;
  color: #60a5fa !important;
}

html.dark .drawer-title {
  color: var(--text-main) !important;
}

html.dark .drawer-close-btn {
  border-color: var(--border-color) !important;
  color: var(--text-muted) !important;
  background: var(--bg-card) !important;
}
html.dark .drawer-close-btn:hover {
  background: var(--bg-hover) !important;
  color: var(--text-main) !important;
}

html.dark .drawer-horizontal-form :deep(.el-form-item__label) {
  color: var(--text-muted) !important;
}
</style>
